import React, { useEffect, useState } from 'react';
import useAliceGPT from '../../Hooks/AliceGPT/useAliceGPT';
import { useTranslation } from 'react-i18next';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import Scrollable from '../Shared/Edit/Scrollable';
import * as AliceGPTEvents from '../../Context/AliceGPT/AliceGPTContextEvents';
import AliceRecommendedEntities from '../Dashboard/Project/AliceGPT/AliceRecommendedEntities';
import AliceRecommendedRelations from '../Dashboard/Project/AliceGPT/AliceRecommendedRelations';
import EditPageConfiguration from '../Dashboard/Project/AliceGPT/EditPageConfiguration';
import { USER_PROFILE_ENTITY } from '../Dashboard/Project/AliceGPT/variables';

import startsWithNumber from '../Helpers/Validators/startsWithNumber';
import { bindShuffleMessageI18nEvents } from '../Shared/ShuffleMessage/MessagesHelper';
import { bindI18nEvents as bindAttributeTypeDropdowni18n } from '../Attributes/Fields/AttributeTypeField';
import { bindI18nEvents as bindAttributeTypeFieldi18n } from '../Shared/Recommendation/AttributeTypeDropdown';
import { generateDDL, generateSchemaSpecificationPDF, storeAppInMongoDB } from '../../API/Integrations/Integrations';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { decryptData } from './utils';
import { useSearchParams } from 'react-router-dom';
import CopilotProjectDetailsForm from './CopilotProjectDetailsForm';
import { Button } from '@progress/kendo-react-buttons';
import { getDatalakeImageUrl } from '../Helpers/DateLakeStorage';
import { digestWorkItemsFile } from '../../API/AliceGPT/AliceGPT';
import { useRef } from 'react';

export function CreateAppFromCopilotForDevops() {

    const { t } = useTranslation([
        "create_project/alice_gpt_dialog",
        "create_project/alice_project_details_form",
        "create_project/alice_recommended_entities",
        "create_project/alice_recommended_attributes_list",
        "create_project/alice_recommended_relations",
        "create_project/edit_page_configurations",
        "linked_entity/recommended_relation_card",
        "common/attribute_type_dropdown",
        "common/attribute_type_field"
    ], { useSuspense: false });

    const [params] = useSearchParams();

    const [state, dispatch] = useAliceGPT();
    const [email, setEmail] = useState("");
    const [jsonDataUrl, setJsonDataUrl] = useState("");
    const [error, setError] = useState("");
    const [emailError, setEmailError] = useState("");
    const descriptionRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [showComplete, setShowComplete] = useState(false);

    const [ddlScript, setDDLScript] = useState("");

    useEffect(() => {
        bindShuffleMessageI18nEvents()
        bindAttributeTypeDropdowni18n()
        bindAttributeTypeFieldi18n()
        dispatch({
            type: AliceGPTEvents.SUBSCRIPTION_LOADED,
            payload: {
                maxEntitiesPerApp: 10,
                maxAttributesPerApp: 15,
                maxRelationsPerApp: 10
            }
        })

        try {
            const emailParam = decodeURIComponent(params.get("d"));
            const json = decryptData(emailParam.replace(" ", "+"));
            let parsed;
            try {
                parsed = JSON.parse(json);
            } catch (e) {
                // If not JSON, treat as email
                setEmail(json);
                // Do not update jsonDataUrl
                return;
            }
            const { email, jsonDataUrl } = parsed;
            setEmail(email);
            setJsonDataUrl(jsonDataUrl);
        } catch (e) {
            setError(e.message);
        }
    }, []);

    function handleMessage(event) {
        // extract email from event.data
        // set email to state
        // const { userEmail } = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        // setEmail(userEmail);
    }

    // function isNextDisabled() {
    //     switch (state.step) {
    //         case 0:
    //             return (
    //                 !state.form.projectName.trim() ||
    //                 /[^a-zA-Z0-9 ]/g.test(state.form.projectName) ||
    //                 entityWithErrorSelected() ||
    //                 startsWithNumber(state.form.projectName.trim())
    //             )
    //         case 1:
    //             const selectedEntities = state.entities.filter(entity => entity.checked);
    //             const hasSameNameAsAnotherEntity = selectedEntities.some((entity, entityIndex) => {
    //                 if (entity.checked) {
    //                     const entityName = entity.name.trim().toLowerCase();
    //                     return selectedEntities.some((e, i) =>
    //                         e.name.trim().toLowerCase() === entityName &&
    //                         i !== entityIndex
    //                     );
    //                 }
    //                 return false;
    //             });
    //             const hasEmptyEntityName = selectedEntities.some(entity => entity.name.trim().length === 0);
    //             const hasEntityNameStartingWithNumber = selectedEntities.some(entity => startsWithNumber(entity.name.trim()));
    //             const entityHasAttributesWithSameName = selectedEntities.some(entity => {
    //                 if (entity.checked) {
    //                     const attributes = entity.attributes.filter(attribute => attribute.selected);
    //                     const attributeNames = attributes.map(attribute => attribute.name.trim().toLowerCase());
    //                     return attributeNames.some(name => attributeNames.filter(n => n === name).length > 1);
    //                 }
    //                 return false;
    //             });
    //             const entityWithNoAttributesSelected = selectedEntities.some(entity => entity.attributes.filter(attribute => attribute.selected).length === 0);
    //             const entityWithMoreThanOneStateAttribute = selectedEntities.some(entity => entity.attributes.filter(attribute => attribute.selected && attribute.type === "State Field").length > 1);
    //             const entityWithPicklistOrStateWith0AttributeSelected = selectedEntities.some(entity => (
    //                 entity.attributes.find(attribute => (
    //                     attribute.selected &&
    //                     (attribute.type === "Picklist String" || attribute.type === "State Field") &&
    //                     (!attribute.picklist || attribute.picklist.length === 0)
    //                 ))
    //             ))
    //             const entityWithAttributesNameWithError = selectedEntities.some(entity => (
    //                 entity.attributes.some(attribute => (
    //                     attribute.selected &&
    //                     (attribute.name.trim().length === 0 || /^\d/g.test(attribute.name))
    //                 ))
    //             ))
    //             const entityWithNoPagesSelected = selectedEntities.some(entity => (
    //                 Object.values(entity.pageConfiguration).every(value => !value)
    //             ))
    //             if (
    //                 hasSameNameAsAnotherEntity ||
    //                 entityHasAttributesWithSameName ||
    //                 hasEmptyEntityName ||
    //                 hasEntityNameStartingWithNumber ||
    //                 entityWithNoAttributesSelected ||
    //                 entityWithMoreThanOneStateAttribute ||
    //                 entityWithPicklistOrStateWith0AttributeSelected ||
    //                 entityWithAttributesNameWithError
    //             ) return true;
    //             if (entityWithNoPagesSelected) return false;
    //             return isCreateAppDisabled();
    //         case 2:
    //             const selectedRelations = state.relations.filter(relation => relation.selected);
    //             const selectedEntitiesWithNoPagesSelected = state.entities.some(entity => (
    //                 entity.checked &&
    //                 Object.values(entity.pageConfiguration).every(value => !value)
    //             ));
    //             if (selectedEntitiesWithNoPagesSelected) return false;
    //             return (
    //                 state.error ||
    //                 !state.initialAttributesLoaded ||
    //                 selectedRelations.length > state.subscription.maxRelationsPerApp
    //             );
    //         default:
    //             return false;
    //     }
    // }

    function isCreateAppDisabled() {
        const selectedEntities = state.entities.filter(entity => entity.checked);
        const isInLoading = selectedEntities.some(entity => entity.attributesLoading);
        if (isInLoading) return true;
        const hasSameNameAsAnotherEntity = selectedEntities.some((entity, entityIndex) => {
            if (entity.checked) {
                const entityName = entity.name.trim().toLowerCase();
                return selectedEntities.some((e, i) =>
                    e.name.trim().toLowerCase() === entityName &&
                    i !== entityIndex
                );
            }
            return false;
        });
        const entityHasAttributesWithSameName = selectedEntities.some(entity => {
            if (entity.checked) {
                const attributes = entity.attributes.filter(attribute => attribute.selected);
                const attributeNames = attributes.map(attribute => attribute.name.trim().toLowerCase());
                return attributeNames.some(name => attributeNames.filter(n => n === name).length > 1);
            }
            return false;
        });
        const entityWithNoAttributesSelected = selectedEntities.some(entity => entity.attributes.filter(attribute => attribute.selected).length === 0);
        const entityWithMoreThanOneStateAttribute = selectedEntities.some(entity => entity.attributes.filter(attribute => attribute.selected && attribute.type === "State Field").length > 1);
        const entityWithPicklistOrStateWith0AttributeSelected = selectedEntities.some(entity => (
            entity.attributes.find(attribute => (
                attribute.selected &&
                (attribute.type === "Picklist String" || attribute.type === "State Field") &&
                (!attribute.picklist || attribute.picklist.length === 0)
            ))
        ))
        const entityWithAttributesNameWithError = selectedEntities.some(entity => (
            entity.attributes.some(attribute => (
                attribute.selected &&
                (attribute.name.trim().length === 0 || /^\d/g.test(attribute.name))
            ))
        ))
        const entityWithNoPagesSelected = selectedEntities.some(entity => (
            Object.values(entity.pageConfiguration).every(value => !value)
        ))
        const entitySubscriptionLimitExceeded = selectedEntities.length > state.subscription.maxEntitiesPerApp;
        const attributeSubscriptionLimitExceeded = selectedEntities.some(entity => entity.attributes.filter(attribute => attribute.selected).length > state.subscription.maxAttributesPerApp);
        const relationSubscriptionLimitExceeded = state.relations.filter(relation => relation.selected).length > state.subscription.maxRelationsPerApp;
        return (
            entityWithNoAttributesSelected ||
            entityWithMoreThanOneStateAttribute ||
            entityWithPicklistOrStateWith0AttributeSelected ||
            hasSameNameAsAnotherEntity ||
            entityHasAttributesWithSameName ||
            entityWithAttributesNameWithError ||
            entityWithNoPagesSelected ||
            entitySubscriptionLimitExceeded ||
            attributeSubscriptionLimitExceeded ||
            relationSubscriptionLimitExceeded
        )
    }

    function entityWithErrorSelected() {
        return state.entities.some(entity => entity.hasAttributeLoadingError && entity.checked);
    }

    async function handleNext() {
        if (state.step === 0 && jsonDataUrl && state.form.passWorkItemFields) {
            setLoading(true);
            const response = await digestWorkItemsFile(jsonDataUrl);
            const newform = { ...state.form, workItemInformation: response.description };
            descriptionRef.current = response.description;
            dispatch({ type: AliceGPTEvents.FORM_UPDATED, payload: newform });
            setLoading(false);
        } else if (state.step === 1) {
            const numSelectedEntities = state.entities.filter(entity => entity.checked).length;
            // if (numSelectedEntities <= 2) {
            //     dispatch({ type: AliceGPTEvents.NEXT });
            // }
        }
        dispatch({ type: AliceGPTEvents.NEXT });
    }

    function isNextDisabled() {
        const selectedEntities = state.entities.filter(entity => entity.checked);
        if (state.step === 0) {
            return (
                !state.form.projectName.trim() ||
                /[^a-zA-Z0-9 ]/g.test(state.form.projectName) ||
                entityWithErrorSelected() ||
                startsWithNumber(state.form.projectName.trim())
            )
        } else if (state.step === 1) {
            const hasSameNameAsAnotherEntity = selectedEntities.some((entity, entityIndex) => {
                if (entity.checked) {
                    const entityName = entity.name.trim().toLowerCase();
                    return selectedEntities.some((e, i) =>
                        e.name.trim().toLowerCase() === entityName &&
                        i !== entityIndex
                    );
                }
                return false;
            });
            const hasEmptyEntityName = selectedEntities.some(entity => entity.name.trim().length === 0);
            const hasEntityNameStartingWithNumber = selectedEntities.some(entity => startsWithNumber(entity.name.trim()));
            const entityHasAttributesWithSameName = selectedEntities.some(entity => {
                if (entity.checked) {
                    const attributes = entity.attributes.filter(attribute => attribute.selected);
                    const attributeNames = attributes.map(attribute => attribute.name.trim().toLowerCase());
                    return attributeNames.some(name => attributeNames.filter(n => n === name).length > 1);
                }
                return false;
            });
            const entityWithNoAttributesSelected = selectedEntities.some(entity => entity.attributes.filter(attribute => attribute.selected).length === 0);
            const entityWithMoreThanOneStateAttribute = selectedEntities.some(entity => entity.attributes.filter(attribute => attribute.selected && attribute.type === "State Field").length > 1);
            const entityWithPicklistOrStateWith0AttributeSelected = selectedEntities.some(entity => (
                entity.attributes.find(attribute => (
                    attribute.selected &&
                    (attribute.type === "Picklist String" || attribute.type === "State Field") &&
                    (!attribute.picklist || attribute.picklist.length === 0)
                ))
            ))
            const entityWithAttributesNameWithError = selectedEntities.some(entity => (
                entity.attributes.some(attribute => (
                    attribute.selected &&
                    (attribute.name.trim().length === 0 || /^\d/g.test(attribute.name))
                ))
            ))
            const entityWithMoreThan30Chars = selectedEntities.some(entity => entity.name.trim().length > 30);
            const entityWithAttributesNameWithMoreThan30Chars = selectedEntities.some(entity => {
                if (entity.checked) {
                    const attributes = entity.attributes.filter(attribute => attribute.selected);
                    const attributeNames = attributes.map(attribute => attribute.name.trim());
                    return attributeNames.some(name => name.length > 30);
                }
            })
            const entitySubscriptionLimitExceeded = selectedEntities.length > state.subscription.maxEntitiesPerApp;
            const attributeSubscriptionLimitExceeded = selectedEntities.some(entity => entity.attributes.filter(attribute => attribute.selected).length > state.subscription.maxAttributesPerApp);
            return (
                entitySubscriptionLimitExceeded ||
                attributeSubscriptionLimitExceeded ||
                hasSameNameAsAnotherEntity ||
                hasEmptyEntityName ||
                hasEntityNameStartingWithNumber ||
                entityHasAttributesWithSameName ||
                entityWithNoAttributesSelected ||
                entityWithMoreThanOneStateAttribute ||
                entityWithPicklistOrStateWith0AttributeSelected ||
                entityWithAttributesNameWithError ||
                entityWithMoreThan30Chars ||
                entityWithAttributesNameWithMoreThan30Chars
            )
        } else if (state.step === 2) {
            const relationSubscriptionLimitExceeded = state.relations.filter(relation => relation.selected).length > state.subscription.maxRelationsPerApp;
            return relationSubscriptionLimitExceeded;
        }
    }

    function handleBack() {
        if (state.step === 3) {
            const numSelectedEntities = state.entities.filter(entity => entity.checked).length;
            if (numSelectedEntities <= 2) {
                dispatch({ type: AliceGPTEvents.BACK });
            }
        }
        dispatch({ type: AliceGPTEvents.BACK })
    }

    const handleSubmit = async () => {
        setShowComplete(true);

        // const selectedEntities = state.entities.length === 0 ? [USER_PROFILE_ENTITY] : getSelectedEntities();
        // const selectedRelations = state.entities.length === 0 ? [] : getSelectedRelations();

        // const entitiesAndAttributes = selectedEntities.map((entity) => ({
        //     name: entity.name,
        //     icon: entity.icon,
        //     isUserEntity: entity.isUserEntity,
        //     attributes: entity.attributes.map((attribute) => {
        //         let picklist = attribute.picklist;
        //         if (attribute.type === "State Field" && attribute.picklist.length === 0) {
        //             picklist = ["Not Started", "In Progress", "Completed"];
        //         }
        //         return {
        //             name: attribute.name,
        //             type: attribute.type,
        //             picklist: picklist,
        //             required: attribute.required,
        //             unique: attribute.unique,
        //             isAzureAttribute: attribute.isAzureAttribute,
        //             sysName: attribute.sysName
        //         }
        //     }),
        //     pageConfiguration: entity.pageConfiguration
        // }));

        // setLoading(true);

        // const response = await storeAppInMongoDB(
        //     email,
        //     {
        //         projectName: state.form.projectName,
        //         description: state.form.description,
        //         entities: entitiesAndAttributes,
        //         relations: selectedRelations
        //     }
        // );

        // setLoading(false);

        // setShowComplete(true);
    }

    async function storeAppMetaDataInMongoDB() {
        const selectedEntities = state.entities.length === 0 ? [USER_PROFILE_ENTITY] : getSelectedEntities();
        const selectedRelations = state.entities.length === 0 ? [] : getSelectedRelations();

        const entitiesAndAttributes = selectedEntities.map((entity) => ({
            name: entity.name,
            icon: entity.icon,
            isUserEntity: entity.isUserEntity,
            attributes: entity.attributes.map((attribute) => {
                let picklist = attribute.picklist;
                if (attribute.type === "State Field" && attribute.picklist.length === 0) {
                    picklist = ["Not Started", "In Progress", "Completed"];
                }
                return {
                    name: attribute.name,
                    type: attribute.type,
                    picklist: picklist,
                    required: attribute.required,
                    unique: attribute.unique,
                    isAzureAttribute: attribute.isAzureAttribute,
                    sysName: attribute.sysName
                }
            }),
            pageConfiguration: entity.pageConfiguration
        }));

        setLoading(true);

        const response = await storeAppInMongoDB(
            email,
            {
                projectName: state.form.projectName,
                description: state.form.description,
                entities: entitiesAndAttributes,
                relations: selectedRelations
            }
        );

        setLoading(false);
    }

    function getSelectedEntities() {
        return state.entities.filter(entity => entity.checked).map(entity => ({
            ...entity,
            attributes: entity.attributes.filter(attribute => {
                return attribute.selected
            })
        }));
    }

    function getSelectedRelations() {
        return state.relations.filter(relation => relation.selected);
    }

    // May require changes
    function showActions() {
        if (state.step === 2) {
            const selectedEntities = state.entities.filter(entity => entity.checked);
            return selectedEntities.length > 1 ? state.relationsLoaded : true;
        }
        return true;
    }

    // function isThereEntityWithDuplicateNames() {
    //     const selectedEntities = state.entities.filter(entity => entity.checked);
    //     return selectedEntities.some((entity, entityIndex) => {
    //         const entityName = entity.name.trim().toLowerCase();
    //         return selectedEntities.some((e, i) =>
    //             e.name.trim().toLowerCase() === entityName &&
    //             i !== entityIndex
    //         );
    //     });
    // }

    async function handleCreate() {
        await storeAppMetaDataInMongoDB();

        const url = `${process.env.REACT_APP_DESIGNER_URL}/signup?email=${email}&isFromCopilot=true`;
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.click();
    }

    function handleEmailError() {
        const email = email.trim();
        if (email.length === 0) {
            setEmailError("Email is required.");
        } else if (!isValidEmail(email)) {
            setEmailError("Email format not accepted.");
        } else {
            setEmailError("");
        }
    }

    function isValidEmail(email) {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    }
    async function handleCreate() {
        await storeAppMetaDataInMongoDB();
        
        const url = `${process.env.REACT_APP_DESIGNER_URL}/signup?email=${email}&isFromCopilot=true`;

        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.click();
    }

    const stepContent = [
        <CopilotProjectDetailsForm showPassWorkItemFields={!!jsonDataUrl} showAIFields checkDuplicateProjectName={() => false} />,
        <AliceRecommendedEntities isFromExtension descriptionRef={descriptionRef} />,
        <AliceRecommendedRelations isFromExtension descriptionRef={descriptionRef} />,
        // below is temporarily removed so commented
        // <EditPageConfiguration isFromExtension />
    ]

    const stepDialogActions = [
        <DialogActionsBar>
            <div className='mx-3 d-flex justify-content-end'>
                <button className='btn btn-primary' onClick={handleNext} disabled={isNextDisabled()}>
                    {t("buttons.next")}
                </button>
            </div>
        </DialogActionsBar>,
        <DialogActionsBar>
            <div className='mx-3 d-flex justify-content-between'>
                {
                    state.isLoadingEntities ?
                        <>
                            <div>
                                <button className='btn btn-outline-secondary' onClick={handleBack}>
                                    {t("buttons.back")}
                                </button>
                            </div>
                            <div>
                                <button className='btn btn-primary' onClick={handleNext} disabled>
                                    {t("buttons.next")}
                                </button>
                            </div>
                        </>
                        :
                        <>
                            {/* {
                                state.entities.some(entity => (
                                    entity.attributes.filter(attribute => (
                                        attribute.selected && attribute.type === "State Field"
                                    )).length > 1
                                )) &&
                                <span className='text-danger'>
                                    {t("errors.only_one_state_allowed")}
                                </span>
                            } */}
                            {/* {
                                isThereEntityWithDuplicateNames() &&
                                <span className='text-danger'>
                                    {t("errors.duplicate_entity_names")}
                                </span>
                            } */}
                            <div>
                                <button className='btn btn-outline-secondary' onClick={handleBack}>
                                    {t("buttons.back")}
                                </button>
                            </div>
                            <div>
                                <button className='btn btn-primary' onClick={handleNext} disabled={isNextDisabled()}>
                                    {t("buttons.next")}
                                </button>
                            </div>
                        </>
                }
            </div>
        </DialogActionsBar>,
        // below is temporarily altered so commented
        // <DialogActionsBar>
        //     <div className='mx-3 d-flex justify-content-between'>
        //         <div>
        //             <button className='btn btn-outline-secondary' onClick={handleBack}>
        //                 {t("buttons.back")}
        //             </button>
        //         </div>
        //         <div>
        //             <button className='btn btn-primary' onClick={handleNext} disabled={isNextDisabled()}>
        //                 {t("buttons.next")}
        //             </button>
        //         </div>
        //     </div>
        // </DialogActionsBar>,
        <DialogActionsBar>
            <div className='mx-3 d-flex justify-content-between'>
                <div>
                    <button className='btn btn-outline-secondary' onClick={handleBack}>
                        {t("buttons.back")}
                    </button>
                </div>
                <div>
                    <button className='btn btn-primary' onClick={handleSubmit} disabled={isCreateAppDisabled()}>
                        {t("buttons.create_app")}
                    </button>
                </div>
            </div>
        </DialogActionsBar>
    ]

    if (loading) {
        return (
            <div className="d-flex flex-column justify-content-enter align-items-center w-100 h-100">
                <div style={{ height: "80%" }}>
                    <img
                        alt="loader-clone"
                        height={"100%"}
                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/loaders/library.gif`} />
                </div>
            </div>
        )
    }

    if (showComplete) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center text-center w-100 h-100">
                <img
                    height={"200px"}
                    src={getDatalakeImageUrl("App is live.png")}
                />
                <h3 className='my-4 col-md-4 col-sm-12 confirm-app-heading'>
                    Congratulations, your application is on the way.
                    <br />
                    Please provide an email to use for your Codeless ONE account. This will allow you to access the app you've just created.
                </h3>
                <div className='my-4 col-md-2 col-sm-12'>
                    <input
                        className='form-control cp-email-input'
                        type='email'
                        placeholder='Email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onBlur={handleEmailError}
                    />
                    {
                        emailError &&
                        <span className='text-danger'>
                            {emailError}
                        </span>
                    }
                </div>
                <button
                    className='k-button k-button-lg k-button-rectangle k-button-solid k-button-solid-primary k-rounded-md'
                    target='_blank'
                    onClick={handleCreate}
                    disabled={!(email && email.length > 0 && email.trim().length > 0 && isValidEmail(email))}
                >
                    <span className='k-button-text'>
                        Sign up / Sign in
                    </span>
                </button>
            </div>
        )
    }

    if (error) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                <h1>Error: {error}</h1>
            </div>
        )
    }

    if (ddlScript && ddlScript.length > 0) {
        return (
            <div className="h-100">
                <button className='btn' style={{ backgroundColor: oneDark.background }} onClick={() => {
                    // Copy to clipboard ddlScript
                    navigator.clipboard.writeText(ddlScript);
                }}>
                    Copy
                </button>
                <button className='btn' onClick={() => { setDDLScript("") }}>
                    Back
                </button>
                <SyntaxHighlighter language="sql" style={{ ...oneDark, maxHeight: "75%" }}>
                    {ddlScript}
                </SyntaxHighlighter>
            </div>
        )
    }

    return (
        <>
            <div style={{ height: "92%" }}>
                <Scrollable>
                    {stepContent[state.step]}
                </Scrollable>
            </div>
            {
                showActions() && stepDialogActions[state.step]
            }
        </>
    )
}

export default CreateAppFromCopilotForDevops;